import React from 'react'
import './styles.scss'

const LayoutGallery = (props) => {
  return <div className='layout-gallery'>{props.children}</div>
}

export default LayoutGallery
